/* Source: /home/sidsolaiyappan/skooch_ai/shared/nav_bar.jac */
import {__jacJsx, __jacSpawn} from "@jac/runtime";
import { useStoreSlice, getStoreUserId, subscribeStoreUserId, getStoreCurrentPage, subscribeStoreCurrentPage, getStoreSchDevScenarioActive, subscribeStoreSchDevScenarioActive, getStoreIsAnonymous, subscribeStoreIsAnonymous, getStoreAccountClaimed, subscribeStoreAccountClaimed, getStoreClaimPending, subscribeStoreClaimPending } from "./store.js";
import { isDevXray } from "./dev_flags.js";
function NavBar(props) {
  const {callbacks} = props;
  let _userId = useStoreSlice(getStoreUserId, subscribeStoreUserId);
  let hasAccount = (_userId ? true : false);
  let currentPage = useStoreSlice(getStoreCurrentPage, subscribeStoreCurrentPage);
  let schDevScenarioActive = useStoreSlice(getStoreSchDevScenarioActive, subscribeStoreSchDevScenarioActive);
  let isAnonymous = useStoreSlice(getStoreIsAnonymous, subscribeStoreIsAnonymous);
  let accountClaimed = useStoreSlice(getStoreAccountClaimed, subscribeStoreAccountClaimed);
  let claimPending = useStoreSlice(getStoreClaimPending, subscribeStoreClaimPending);
  let _devXray = isDevXray();
  let cb = callbacks;
  let onBrandClick = cb["onBrandClick"];
  let onNavDashboard = cb["onNavDashboard"];
  let onNavScheduler = cb["onNavScheduler"];
  let onNavProfile = cb["onNavProfile"];
  let onNavLearning = cb["onNavLearning"];
  let onNavSandbox = cb["onNavSandbox"];
  let onSaveAccount = cb["onSaveAccount"];
  let onLogout = cb["onLogout"];
  let onLogin = cb["onLogin"];
  let onSignup = cb["onSignup"];
  return __jacJsx("nav", {"className": "nav"}, [__jacJsx("button", {"className": "nav-brand", "onClick": () => {
    onBrandClick();
  }}, ["skooch.ai"]), (hasAccount ? __jacJsx("div", {"className": "nav-links"}, [__jacJsx("button", {"className": ((currentPage === "dashboard") ? "nav-link nav-link-page nav-link-active" : "nav-link nav-link-page"), "onClick": () => {
    onNavDashboard();
  }}, ["Dashboard"]), __jacJsx("button", {"className": (((currentPage === "scheduler") && !schDevScenarioActive) ? "nav-link nav-link-page nav-link-active" : "nav-link nav-link-page"), "onClick": () => {
    onNavScheduler();
  }}, ["Scheduler"]), __jacJsx("button", {"className": ((currentPage === "profile") ? "nav-link nav-link-page nav-link-active" : "nav-link nav-link-page"), "onClick": () => {
    onNavProfile();
  }}, ["Profile"]), (_devXray ? __jacJsx("button", {"className": ((currentPage === "learning") ? "nav-link nav-link-active" : "nav-link"), "onClick": () => {
    onNavLearning();
  }}, ["Learning"]) : null), __jacJsx("button", {"className": (((currentPage === "scheduler") && schDevScenarioActive) ? "nav-link nav-link-page nav-link-active" : "nav-link nav-link-page"), "onClick": () => {
    onNavSandbox();
  }}, ["Sandbox"]), ((((hasAccount && isAnonymous) && !accountClaimed) && !claimPending) ? __jacJsx("button", {"className": "nav-link nav-link-save-account", "onClick": () => {
    onSaveAccount();
  }}, ["Save account"]) : ((((hasAccount && isAnonymous) && !accountClaimed) && claimPending) ? __jacJsx("button", {"className": "nav-link nav-link-claim-pending", "title": "Check your email to confirm and finish saving your account.", "onClick": () => {
    onSaveAccount();
  }}, ["\u23f3 Pending \u2014 check email"]) : null)), __jacJsx("button", {"className": "nav-link nav-link-logout", "onClick": () => {
    onLogout();
  }}, ["Log out"])]) : __jacJsx("div", {"className": "nav-links"}, [__jacJsx("button", {"className": "nav-link", "onClick": () => {
    onLogin();
  }}, ["Log In"]), __jacJsx("button", {"className": "nav-link", "onClick": () => {
    onSignup();
  }}, ["Sign Up"])]))]);
}
export {NavBar};
if (typeof globalThis !== "undefined") { if (!globalThis.__jacEndpointEffects__) globalThis.__jacEndpointEffects__ = {}; Object.assign(globalThis.__jacEndpointEffects__, {"func:NavBar": {"is_writer": false, "touches": ["*"]}}); };
//# sourceMappingURL=nav_bar.js.map
